import Block from './Block'

export default class CoverProject extends Block {
  onEnterCompleted() {
    setTimeout(() => {
      this.title.classList.add('is-inview')
      this.info.classList.add('is-inview')
      this.cta && this.cta.classList.add('is-visible')
      this.content.classList.add('v')
    }, 200)
  }

  getElems() {
    this.title = this.el.querySelector('.c-cover-project__title')
    this.info = this.el.querySelector('.c-cover-project__info')
    this.cta = this.el.querySelector('.c-cover-project__cta')
    this.content = this.el.nextElementSibling
  }
}
